module.exports = __webpack_public_path__ + "img/Eventos_editar_formulario.907fe827.svg";